import React from 'react'
import { IDocumentALCOReportParams, IDocumentReportParams } from 'types'

interface Props {}

interface Hook {
    params: IDocumentALCOReportParams
    handleChangeParams: (key: string, value: any) => void
}


const useALCOReportParams = (props?: Props): Hook => {
    const [params, setParams] = React.useState<IDocumentALCOReportParams>({
        almaceneras: { yearMonth: new Date() },
        consiliacion: { yearMonth: new Date() }
    })
    const handleChangeParams = (key: string, value: any) => {
        setParams(current => ({
            ...current,
            [key]: value
        }))
    }
    return {
        params,
        handleChangeParams
    }
}

export default useALCOReportParams
